import { effects } from 'redux-saga'

import callWithHmac from '../effects/callWithHmac'
import { begin, end } from '../../modules/loading'
import { receiveCoupons } from '../../modules/product'

export default function* loadCoupons({ invocation }) {
  try {
    yield effects.put.resolve(begin('coupons'))

    const results = yield effects.call(callWithHmac, invocation.getCoupons)

    yield effects.put.resolve(receiveCoupons(results.coupons))
  } finally {
    yield effects.put.resolve(end('coupons'))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/product/loadCoupons.js